import { render, staticRenderFns } from "./SubOverlay.vue?vue&type=template&id=1f1a87bc&"
import script from "./SubOverlay.vue?vue&type=script&lang=js&"
export * from "./SubOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f1a87bc')) {
      api.createRecord('1f1a87bc', component.options)
    } else {
      api.reload('1f1a87bc', component.options)
    }
    module.hot.accept("./SubOverlay.vue?vue&type=template&id=1f1a87bc&", function () {
      api.rerender('1f1a87bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/SubOverlay.vue"
export default component.exports